import { render } from "./PendingSvg.vue?vue&type=template&id=4c1358f6"
const script = {}

import exportComponent from "/home/lexmodo/Vue/FraudLabs/fraudlabs_vue/fraudlabs_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__